/**
 * Configuration OIDC pour l'authentification UQAM via SimpleSAML.
 * Toutes les URLs sont construites dynamiquement via VUE_APP_OIDC_SERVER_BASE_URL.
 */
export const oidcSettings = {
  authority: `${process.env.VUE_APP_OIDC_SERVER_BASE_URL}/simplesaml/module.php/oidc/authorize.php`,
  client_id: `${process.env.VUE_APP_OIDC_CLIENT_ID}`,
  redirect_uri: `${window.location.origin}/oidc-callback/`,
  response_type: 'id_token token',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 600, // (10 mins)
  silent_redirect_uri: `${window.location.origin}/silent-renew-oidc.html`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  loadUserInfo: true,
  filterProtocolClaims: true,
  metadata: {
    issuer: process.env.VUE_APP_OIDC_SERVER_BASE_URL,
    jwks_uri: `${process.env.VUE_APP_OIDC_SERVER_BASE_URL}/simplesaml/module.php/oidc/jwks.php`,
    end_session_endpoint: `${process.env.VUE_APP_OIDC_SERVER_BASE_URL}/simplesaml/module.php/oidc/logout.php`,
    authorization_endpoint: `${process.env.VUE_APP_OIDC_SERVER_BASE_URL}/simplesaml/module.php/oidc/authorize.php`,
    userinfo_endpoint: `${process.env.VUE_APP_OIDC_SERVER_BASE_URL}/simplesaml/module.php/oidc/userinfo.php`,
  },
}
